import { apiSlice } from './apiSlice';

export interface PlanetAwastha {
  name: string;
  planetAwastha: string;
}

export const planetAwasthaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetAwastha: builder.query<PlanetAwastha[], string | null>({
      query: (userId) => ({
        url: '/astrology/planet-awastha',
        method: 'GET',
        params: { userId },
      }),
    }),
  }),
});

export const { useGetPlanetAwasthaQuery } = planetAwasthaApi;
